import React from 'react';
import styled from 'styled-components';
import { Flex } from '../shared/Flex';

const Wrapper = styled(Flex)`
  position: relative;
  height: auto;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(59, 130, 246, 0.2); // Light Blue
  border: 1px solid #3B82F6;
  border-radius: 8px;
  padding: 10px 20px;
  box-sizing: border-box;
`;

const Message = styled.div`
  padding: 5px;
  font-size: 14px;
  color: #d84242;
  text-align: center;
`;

const InfoAlert = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <Wrapper>
      <Message>{message}</Message>
    </Wrapper>
  );
};
export default InfoAlert;
